var _rect, _circle, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 24,
    fill: "#4285F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3064 18.8421C18.0407 21.6645 15.5967 25.3154 14.2317 29.4102C12.8667 33.505 12.6313 37.8921 13.5502 42.1095C14.4691 46.3268 16.5084 50.2183 19.4532 53.374C22.398 56.5297 26.1393 58.8329 30.2831 60.0409C34.4269 61.2489 38.8198 61.317 42.9991 60.2381C47.1784 59.1592 50.9894 56.9732 54.0306 53.9103C57.0719 50.8474 59.2308 47.021 60.2801 42.8342C61.3293 38.6474 61.2301 34.2551 59.9927 30.1199L37 37L21.3064 18.8421Z",
    fill: "#00B42A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.5923c306935e6c5b8ba6502b6f3330cb.svg";
export { ForwardRef as ReactComponent };